import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class LinkedinService {
  private linkedInAuthUrl = 'https://www.linkedin.com/oauth/v2/authorization';
  private clientId = '';
  private redirectUri = window.location.origin + '/login';

  constructor(private http: HttpClient, private authService: AuthService, private userService: UserInfoService) {
    this.getLinkedInToken();
  }

  getLinkedInToken() {
    this.http.get(`assets/${environment.projectName}/auth/credentials.json`).subscribe((response: any) => {
      this.clientId = response.linkedin.clientId;
    });
  }

  loginWithLinkedIn(): void {
    const state = this.generateState();
    const authUrl = `${this.linkedInAuthUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}&scope=openid%20profile%20email&state=${state}`;
  
    const popup = window.open(authUrl, 'LinkedIn Login', 'width=600,height=600');
  
    if (!popup) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }
  
    const interval = setInterval(() => {
      try {
        const url = popup.location.href;
        if (url.indexOf(this.redirectUri) === 0) {
          const code = this.extractCodeFromUrl(url);
          if (code) {            
            clearInterval(interval);
            popup.close();
            this.exchangeCodeForToken(code);
          }
        }
      } catch (error) {}
    }, 1000);
  }
  
  private extractCodeFromUrl(url: string): string | null {
    const params = new URLSearchParams(url.split('?')[1]);
    return params.get('code');
  }
  
  private exchangeCodeForToken(code: string): void {
    this.authService.loginWithLinkedIn(code).subscribe((response: any) => {
      this.userService.setUserInfo(response);
      window.location.href = '/';
    });
  }
  
  private generateState(): string {
    return Math.random().toString(36).substring(7);
  }
  
}